// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2528":"3b0539a9","2821":"abb2e847","4349":"916abaa6","5096":"916abaa6","5749":"2e01e46a","7516":"8a157051","8547":"c7613d2f","8983":"a575b9ba","9138":"0cc75aa7"}[chunkId] + ".chunk.css";
};